import React, { useContext } from "react";
import { LabelContext } from "../labels/LabelContext";
import { GroupContext } from '../layout/GroupContext';
import classNames from "classnames";
import Select, { MultiValue } from 'react-select';
import { InlineOrBlockSize, ValidationState } from "../Types";
import { SelectOption } from "./Select";
import { reactSelectStyles } from "../pickers/PickerStyles";

export interface MultiSelectProps<T> {
  /**
   * Id of the element
   */
  id?: string;
  /**
   * Name of the element
   */
  name?: string;
  /**
   * Id of the HTML element describing the input
   */
  describedBy?: string;
  /**
   * Options specifying Radio Buttons
   */
  options: SelectOption<T>[];
  /**
   * Value of the selected Radio Button
   */
  value: SelectOption<T>[];
  /**
   * Value change handler
   */
  onChange: (v: SelectOption<T>[]) => any;
  /**
   * Size
   */
  size?: InlineOrBlockSize;
  /**
   * Element validation state
   */
  state?: ValidationState;
  /**
   * Disables element
   */
  disabled?: boolean;
  /**
   * Custom class
   */
  className?: string;
  /**
   * Placeholder text
   */
  placeholder?: string;
}

/**
 * Displays lists of radio buttons
 */
export const MultiSelect = <T extends unknown>(props: MultiSelectProps<T>) => {

  const onChange = (v: MultiValue<SelectOption<T>>) => {
    props.onChange(v as []);
  }

  const labelCtx = useContext(LabelContext);
  const groupCtx = useContext(GroupContext);
  const state = labelCtx.state || props.state;

  return (<Select
    isMulti
    id={props.id || labelCtx.id}
    name={props.name}
    options={props.options}
    value={props.value || []}
    styles={reactSelectStyles(state)}
    className={classNames(groupCtx.className, props.className)}
    placeholder={props.placeholder}
    onChange={onChange}
    isDisabled={props.disabled}
    aria-labelledby={props.describedBy || labelCtx.describedBy}
  />)
}